var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkerBpLogoHLightText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#e5e0dd;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#54284e;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#0d361c;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 95.17,
    y1: 55.82,
    x2: 118.78,
    y2: 62.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac6244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8d2700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8f2a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#94340f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9c4421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a85a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa5e3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -329.1,
    y1: 330.02,
    x2: -272.24,
    y2: 348.5,
    gradientTransform: "translate(365.91 -284.75) rotate(3.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e006d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ad006d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c4006d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d2006d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d7006d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d80670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#db1778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e13386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e95a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f28bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f391b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#f498bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f49abc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f27bb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ef469b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ec208c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#eb0983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ea0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e0007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c60079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#9b0070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e006d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.77,
    y1: 80.67,
    x2: 17.5,
    y2: 80.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00822c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -334.72,
    y1: 401.63,
    x2: -278.64,
    y2: 434.01,
    gradientTransform: "translate(365.91 -284.75) rotate(3.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#109840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0d943c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#048831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00822c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -308.05,
    y1: 352.34,
    x2: -228.31,
    y2: 369.21,
    gradientTransform: "translate(365.91 -284.75) rotate(3.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8d2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9b391c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#bf6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f5ad2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f5ad2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f2a32c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e98a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#dc6029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#d03c27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.49,
    y1: 80.94,
    x2: 83.13,
    y2: 101.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005d33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#096339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#237349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4d8d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#86b186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#b2cda1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b2cda1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#73bb7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#42ad5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1ea345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#089c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#009a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#005d33"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.1,89.82h-46l-11.86,26.53h-9.78L173.1,29.06h10.51l39.61,87.29H212.71ZM178.24,38.11,158.8,81.51h38.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.38,28.33h9V83.71l38.76-30.93h13.45L257.45,76.86,291,116.35H279L250.73,82.73,236.42,93.61v22.74h-9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.76,96.06c-3.67,11.24-13.2,22.25-34.23,22.25-26,0-34.6-18.22-34.6-33.75,0-17.72,10.88-33.74,34.6-33.74,16.38,0,35.82,7.09,35.82,35.94H295c0,13.21,9.41,24,25.55,24,15.16,0,22-5,25.18-14.67ZM347.3,79.92c-2.56-15.65-14.06-21.52-26.16-21.52-11.61,0-24.08,6-26.16,21.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.27,52.78h9.05V67.33h.24c3.3-7.58,9.29-16.51,24.33-16.51a27,27,0,0,1,5.38.49V60.6a47.61,47.61,0,0,0-8.31-.73c-9.78,0-21.64,6-21.64,24.08v32.4h-9.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.53,29.06h49.63c17.12,0,24.33,9.66,24.33,22,0,8.43-4.65,16.26-15,18.7V70c11.49,1.71,18.46,10.14,18.46,21.39,0,18.22-15.4,24.94-28.85,24.94H409.53Zm9,37.9h35.82c12.23,0,20.05-3.91,20.05-15.53,0-10.63-7.09-14.06-17-14.06H418.57Zm0,41.08h38c11.74,0,20.54-4.65,20.54-16.63,0-12.59-7.82-16.14-18.34-16.14H418.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.61,29.06h47.07c13.45,0,26.28,6.73,26.28,25.19,0,16.5-10.88,25.42-30.32,25.42h-34v36.68h-9.05Zm9.05,42.3h35c15.16,0,19.56-7,19.56-17.11,0-13.09-7.33-16.88-17.72-16.88h-36.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.76,53.52c.24-1.54.43-2.84.59-4,0,0,0,.06,0,.08-.74,4-4.42,1.77-5.89.79C106.8,45.34,95,40.26,97.34,53.9c2.19,12.73,18,18.29,17.84,21.13a143.66,143.66,0,0,0,4.48-20.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.6,6.57c-.47.84.25,1.67,1.44,2.78,3.51-2.95.14-5.16-1.3-3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.16,31.44C22.75,28.9,21.47,25.9,22,23a23.24,23.24,0,0,0-4,6.05C17.47,30.05,17.47,31.14,24.16,31.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.43,43.12c-.32-2.3-2.49-3.54-3.24-2h0c-.35.77-.17,2.61,3,3.94A4.69,4.69,0,0,0,15.43,43.12Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.38,48A22.86,22.86,0,0,0,65,42.51c-11-6.77-29.83-10.93-37.7-11-1.18,0-2.22,0-3.13-.08-6.69-.3-6.69-1.39-6.22-2.39A23.24,23.24,0,0,1,22,23c4.75-5.11,10.94-6.88,15.69-8.21C44,13,54.45,7.12,45.34,2.25s-14.72-.53-15.73.85a26.9,26.9,0,0,0-2,3.48l.14-.24c1.45-2.15,4.82.06,1.31,3l-.18.15c-3.93,3.13-8.09,10.21-10.4,15.42C15.31,32,12.19,41.1,12.19,41.1h0c.75-1.52,2.92-.28,3.24,2a4.69,4.69,0,0,1-.2,1.92,17.62,17.62,0,0,1-1.86,3.89C10,54.43,15.09,59.09,19.75,60c4.06.81,27.18-1.21,35.51-2.2,1.26-.15,2.18-.28,2.65-.36C61.43,56.79,76.2,54.39,71.38,48Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.78,79.84l0-.15A1,1,0,0,1,1.78,79.84Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3.22,87C6.1,89.15,11,88.4,17.5,86.91l0,0C9.8,78.84,7.22,72.6,4.41,73c-1.51.23-2.2,4.16-2.61,6.66C1.61,84.06,2.19,86.28,3.22,87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5.3,102.48l-.71-.21a55.23,55.23,0,0,0,6.92,10.65c15.39,18.88,46.1,15.6,53.22,13.14s1.55-7.55-2.67-10.11c-2.47-1.49-9.39-4.09-18.31-9.16C31.12,106.52,15.9,105.41,5.3,102.48Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M108.75,33.06a128.29,128.29,0,0,0-32.69,4.58,39,39,0,0,0-11,4.81l0,.06A22.86,22.86,0,0,1,71.38,48c4.82,6.43-9.95,8.83-13.47,9.51-.47.08-1.39.21-2.65.36h0a22.24,22.24,0,0,0,0,4.51c.36,3.25-1.08,6.65-4.81,7.5s-20.69,5.27-20.83,9a10.91,10.91,0,0,0,1.55,5h0c2.15-.4,4.38-.77,6.72-1.07,16.38-2.11,47.28-6.27,49.22.84h0c8.6-4,13.94-8.69,17.27-10.28,4-1.89,10,3.84,10.76,1.68.19-2.84-15.65-8.4-17.84-21.13-2.35-13.64,9.46-8.56,17.1-3.47,1.47,1,5.15,3.17,5.89-.79,0,0,0,0,0-.08.9-6.35.73-6.71,1.11-10.8C121.92,33.83,113.46,32.9,108.75,33.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.93,82.79c-2.34.3-4.57.67-6.72,1.07-5.15,1-9.75,2.15-13.71,3C11,88.4,6.1,89.15,3.22,87c-1-.75-1.61-3-1.42-7.34l0,.15C1.17,84-.08,92.63,0,96.27c.08,3.46.78,4.83,4.59,6l.71.21c10.6,2.93,25.82,4,38.45,4.31,10.92.24,19.91-.16,22.28-.56,5.13-.85,4.5-4.37,3.78-6.88-.77-2.7-1.43-4.83,2.61-5.83,5.13-1.27,14.26-5,14.8-8.66a3,3,0,0,0-.07-1.23C85.21,76.52,54.31,80.68,37.93,82.79Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkerBpLogoHLightText);
export default __webpack_public_path__ + "static/media/AkerBP-Logo_H_light-text.e85b23df2c891eceb1f4f76ac0c795c8.svg";
export { ForwardRef as ReactComponent };